// extracted by mini-css-extract-plugin
export default {"containerPadding":"incidentForm_containerPadding__KOLg1"};